import { useEffect } from "react";
import { fetchApi } from "@/helpers/h";
import { useData } from "@/stores/data";

/**
 * Custom hook to fetch and manage setting in Zustand store
 * Fetches setting in the background and stores it in the global store
 */
export const useSetting = () => {
  const { setting, setSetting } = useData();

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await fetchApi({
          url: "/v2/setting",
          method: "GET",
        });
        if (res?.data?.success && res?.data?.data) {
          setSetting(res.data.data);
        }
      } catch {
        // Silently fail - use default logo
      }
    };
    fetchSetting();
  }, [setSetting]);

  return { setting };
};
